export default [
  {
    name: "iReport",
    image:
      "https://user-images.githubusercontent.com/101972392/198857856-a1e5e82a-3bec-4a6e-b324-9b53222c72b3.gif",
    lang: "HTML5,CSS3,Javascript,Node.js,Ejs & MongoDB",
    desc: "Report can becreate with details of the incident, Report can also be edited, deleted from the users database.",
    github: "https://github.com/Aladdin4u/report-incident-app",
    live: "https://reportaapp.onrender.com/",
  },
  {
    name: "School Attendance System",
    image: "/images/school-attendance.png",
    lang: "PHP,Laravel,Tailwindcss",
    desc: "Design and development of student dashboard for monitoring and evaluating students attendance to lectures.",
    github: "https://github.com/Aladdin4u/student_attendance",
    live: "https://github.com/Aladdin4u/student_attendance",
  },
  {
    name: "world cup 2022",
    image:
      "https://user-images.githubusercontent.com/101972392/203931456-2138d0b5-b856-42b4-bd9a-3a403d199bbc.gif",
    lang: "HTML5, CSS3, Javascript, React",
    desc: "A LiveScores App to stay updated for all World Cup 2022 matches, stats, fixture and table.",
    github: "https://github.com/Aladdin4u/world-cup-2022",
    live: "https://worldcup2022app.netlify.app/",
  },
  {
    name: "Super Market",
    image:
      "https://user-images.githubusercontent.com/101972392/210287860-049f5144-fbc4-4587-861f-e6d6a3ff4b52.gif",
    lang: "HTML5, CSS3, Javascript, React, TaildwindCss",
    desc: "SuperMarket to order groceries with our easy to use app, and get products delivered straight to your doorstep. We use stripe to process your payment",
    github: "https://github.com/Aladdin4u/supermarket",
    live: "https://supermarkets123.netlify.app/",
  },
  {
    name: "Injury Report App",
    image: "/images/injury-report-app.png",
    lang: "React, NextJs, Prisma, PostgreSQL, GraphQL, Ant Design, ChartJs",
    desc: "A fullstack web application that can be used by an organization (such as the police) to easily record and track the injuries reported by a person",
    github: "https://github.com/Aladdin4u/injury-tracking-system-nextJs",
    live: "injury-tracker-ten.vercel.app",
  },
  {
    name: "Real Estate Pricing",
    image: "/images/real-estate.png",
    lang: "React, NextJs, MindsDB, Tailwindcss, Shadcn ui",
    desc: "A web based application to predict house rent price in Nigeria",
    github: "https://github.com/Aladdin4u/real-estate-pricing",
    live: "https://github.com/Aladdin4u/real-estate-pricing",
  },
  {
    name: "Tenzies",
    image:
      "https://user-images.githubusercontent.com/101972392/201551527-1eb3d0d6-dc37-46c4-8c1d-cdb0dc5c61e7.gif",
    lang: "HTML5, CSS3, Javascript, React",
    desc: "A dice game. Roll until all dice are the same. Click each die to freeze it at its current value between rolls.",
    github: "https://github.com/Aladdin4u/Tenzies",
    live: "https://aladdin4u.github.io/Tenzies/",
  },
  {
    name: "Game of Throne API",
    image:
      "https://user-images.githubusercontent.com/101972392/204691275-7ac6a949-0219-4e57-a4c0-2d6d68f27def.gif",
    lang: "HTML5, CSS3, Javascript, Nodejs, Express",
    desc: "This api runs on Node.js with the help of express. When you send a request to the houses page it return a json object with character list. Each house has a name and a code.",
    github: "https://github.com/Aladdin4u/game-of-thrones-character-api",
    live: "https://gft.onrender.com/",
  },
  {
    name: "Job Hunt",
    image: "/images/jobhunt.png",
    lang: "PHP, Laravel, Tailwindcss",
    desc: "An application where job searcher can find their dream job",
    github: "https://github.com/Aladdin4u/jobhunt",
    live: "https://github.com/Aladdin4u/jobhunt",
  },
];
